// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  padding-top: 5%;
  text-align: center;
  width: 50%;
  padding-left: 25%;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/App/UnknownRoute.less"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAFF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n\n.main {\n  padding-top: 5%;\n  text-align: center;\n  width: 50%;\n  padding-left: 25%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
